import { EventStructuredSchema } from './event-structured-data.interface'
import { createLiveSignupUrlTree, UrlTreeCreator } from '../../live/services/routing.utility'
import { StructuredSchemaElement } from './head-element.interface'
import { makeBaseSchema } from './seo.utility'
import * as f from 'fp-ts/function'
import { LiveEventNodeProps } from './live-event-structured-data.interface'
import { LiveEvent } from '@flocasts/flosports30-types/dist/entity'
import { SiteSettings } from 'src/app/shared/models/site-settings.model'

export const EVENT_SCHEMA_ID = 'event-structured-data'

// TODO: Make this a non-Pick type
export type EventSchemaData = Pick<
  LiveEvent,
  'id' | 'start_date' | 'title' | 'short_title' | 'description' | 'end_date' | 'live_event_url'
> &
  LiveEventNodeProps

export type SiteSchemaData = Pick<SiteSettings, 'site_name' | 'core_site_url' | 'sport_name'>

/**
 * Creates a schema for the Event type.
 *
 * TODO: Move this to seo.utility?
 *
 * @param liveEvent A LiveEvent for which the schema is produced.
 * @param siteSetting The Settings for the site for which the schema is produced.
 * @param router An instance of Router for producing live signup URLs.
 * @param eventHubAsset A URL for an image.
 *
 * @see {@link https://developers.google.com/search/docs/data-types/event}
 * @see {@link https://schema.org/Event}
 */
export function formatEventSchema(
  liveEvent: EventSchemaData,
  siteSetting: SiteSchemaData,
  router: UrlTreeCreator,
  eventHubAsset?: string
): EventStructuredSchema {
  const name = liveEvent.title ?? liveEvent.short_title
  const description = liveEvent.seo_description || `Watch ${liveEvent.title} live!`
  const endDate = liveEvent.end_date
  const startDate = liveEvent.start_date
  const image = Boolean(eventHubAsset) ? [eventHubAsset as string] : undefined

  return {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    eventStatus: 'EventScheduled',
    description,
    sport: siteSetting.sport_name ?? undefined,
    endDate,
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    image,
    location: {
      '@type': 'VirtualLocation',
      url: liveEvent.live_event_url
    },
    name,
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      validFrom: startDate,
      priceCurrency: 'USD',
      price: '12.50',
      url: siteSetting.core_site_url + createLiveSignupUrlTree(router)(liveEvent.id.toString(10), {}).toString()
    },
    organizer: {
      '@type': 'Organization',
      name: siteSetting.site_name || 'FloSports',
      url: siteSetting.core_site_url || 'https://www.flosports.tv'
    },
    startDate
  }
}

function createHeadElement(ess: EventStructuredSchema): StructuredSchemaElement {
  return {
    ...makeBaseSchema(EVENT_SCHEMA_ID),
    innerText: JSON.stringify(ess)
  }
}

export const makeEventHeadElementData = f.flow(formatEventSchema, createHeadElement)
